import { Route, Routes } from "react-router";
import DashboardApp from "./pages/DashboardApp";
import TransactionsApp from "./pages/TransactionsApp";
import BudgetsApp from "./pages/BudgetsApp";

const AppRoutes = () => {
  return (
    <Routes>
      <Route index path="dashboard" element={<DashboardApp />} />
      <Route path="transactions" element={<TransactionsApp />} />
      <Route path="budgets" element={<BudgetsApp />} />
    </Routes>
  );
};

export default AppRoutes;
